module.exports = __webpack_public_path__ + "img/choose-box-hen.cd7f7b9a.png";